import { render, staticRenderFns } from "./ImBox.vue?vue&type=template&id=2fff96a9&"
import script from "./ImBox.vue?vue&type=script&lang=js&"
export * from "./ImBox.vue?vue&type=script&lang=js&"
import style0 from "./ImBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports